export interface MapBounds {
  center: { lat: number; lng: number };
  bounds: { north: number; east: number; south: number; west: number };
}

export interface MapData {
  zoomBounds: MapBounds;
  movementBounds: MapBounds;
}

// Try https://www.birdtheme.org/useful/v3largemap.html to draw a boundary on the map and read its coordinates
export const mapDataPerCountry: { [key: string]: MapData } = {
  CH: {
    zoomBounds: {
      center: {
        lat: 46.813219,
        lng: 8.227386,
      },
      bounds: {
        south: 45.865150,
        west: 7.044983,
        north: 47.724545,
        east: 9.577332,
      },
    },
    movementBounds: {
      center: {
        lat: 46.890232,
        lng: 8.324890
      },
      bounds: {
        south: 45.026950,
        west: 5.053711,
        north: 48.294158,
        east: 11.359863,
      },
    },
  },
  FR: {
    zoomBounds: {
      center: {
        lat: 46.219264949999996,
        lng: 2.05169995
      },
      bounds: {
        south: 42.285437,
        west: -4.801025,
        north: 51.158677,
        east: 8.470459
      },
    },
    movementBounds: {
      center: {
        lat: 46.882723,
        lng: 2.433472
      },
      bounds: {
        south: 38.565348,
        west: -5.646973,
        north: 53.146770,
        east: 10.261230
      },
    },
  },
  DE: {
    zoomBounds: {
      center: {
        lat: 51.1657,
        lng: 10.4515
      },
      bounds: {
        south: 46.904366,
        west: 4.785202,
        north: 55.240818,
        east: 16.123093,
      },
    },
    movementBounds: {
      center: {
        lat: 51.1657,
        lng: 10.4515
      },
      bounds: {
        south: 46.904366,
        west: 4.785202,
        north: 55.240818,
        east: 16.123093,
      },
    },
  },
};
